import { render, staticRenderFns } from "./Notificacion.vue?vue&type=template&id=f3df77ee&scoped=true&"
import script from "./Notificacion.vue?vue&type=script&lang=js&"
export * from "./Notificacion.vue?vue&type=script&lang=js&"
import style1 from "./Notificacion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3df77ee",
  null
  
)

export default component.exports